export const SIGNOUT = 'SIGNOUT';
export const SIGNOUT_SUCCESS = 'SIGNOUT_SUCCESS';
export const REGISTER = 'REGISTER';
export const REGISTER_SUCCESS = 'REGISTER_SUCCESS';
export const ME_INIT = 'ME_INIT';

export const meInit = () => ({
  type: ME_INIT,
})

export const register = (data) => ({
  type: REGISTER,
  data
})

export const registerSuccess = () => ({
  type: REGISTER_SUCCESS,
})

export const signout = () => ({
  type: SIGNOUT,
});

export const signoutSuccess = () => ({
  type: SIGNOUT_SUCCESS
});



/** WEBPACK FOOTER **
 ** ./src/app/modules/me/actions.js
 **/